import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'idp-information-sections',
  templateUrl: './information-sections.component.html',
  styleUrls: ['./information-sections.component.scss']
})
export class InformationSectionsComponent {
  @Input() title = '';
  @Input() message = '';

  @Output() action = new EventEmitter();

  notify() {
    this.action.emit();
  }
}
